const API_ROUTES = Object.freeze({
  LOCATION: "/users/locations/",
});

const QUERY_KEYS = Object.freeze({
  LOCATION: "locations",
})

export { API_ROUTES, QUERY_KEYS };
